// extracted by mini-css-extract-plugin
export default {"container":"style_container__MwixP","wave":"style_wave__xbhRz","innerBox":"style_innerBox__EekWR","tako":"style_tako__S78lg","notFound":"style_notFound__jfUh9"};